import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

function TablesTableRow(props) {
  const { logo, name, email, subdomain, domain, status, date } = props;
  const textColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "#1a202c");
  const colorStatus = useColorModeValue("white", "gray.400");

  return (
    <Tr key={`${props.id}-${props.year}`}>
      <Td minWidth={{ sm: "100px" }} pl="0px">
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Flex direction="column">
            <Text
              fontSize="md"
              color={textColor}
              fontWeight="bold"
            >
              {(props.title || "").substr(0, 60) + "..."}
            </Text>
          </Flex>
        </Flex>
      </Td>

      <Td>
        <Flex direction="column">
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {props.year}
          </Text>
        </Flex>
      </Td>
      <Td>
        <Flex direction="column">
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {props.country}
          </Text>
        </Flex>
      </Td>
      <Td>
        <Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
          {props.language}
        </Text>
      </Td>
      <Td>
      <NavLink to={"/admin/edit/" + props.id.replaceAll("record_","")} key={props.name}>
        <Button
       onClick={ () => {console.debug("test"); } } p="0px" bg="transparent">
                  <Flex color={textColor} cursor="pointer" align="center" p="12px">
                    <Icon as={FaPencilAlt} me="4px" />
                    <Text fontSize="sm" fontWeight="semibold">
                      EDIT
                    </Text>
                  </Flex>
                </Button>
        </NavLink>
      </Td>
    </Tr>
  );
}

export default TablesTableRow;
